import * as React from "react";
import { groupBy } from "lodash";
import {
  HeadingSmall,
  ParagraphMedium,
  ParagraphSmall,
  ParagraphXSmall,
} from "baseui/typography";

import { LI, UL } from "kanopi-components/List";
import { Block } from "kanopi-components/Block";

type TCoverLimitationsListProps = {
  items: TCoverLimitation[];
  artwork: React.ReactNode;
};

const CoverLimitationsList: React.FC<TCoverLimitationsListProps> = ({
  items,
  artwork,
}) => {
  if (!items.length) return null;

  return (
    <UL>
      {items.map((item, index) => (
        <LI
          key={`${index}_${item.key}`}
          artwork={artwork}
          marginBottom="scale800"
          marginRight="scale600"
        >
          <ParagraphSmall margin={0}>{item.text}</ParagraphSmall>
          <ParagraphXSmall margin={0} color="mono700">
            {item.description}
          </ParagraphXSmall>
        </LI>
      ))}
    </UL>
  );
};

const CoverLimitationsGroupedList: React.FC<TCoverLimitationsListProps> = ({
  items,
  artwork,
}) => {
  if (!items.length) return null;

  // TODO: Is cover.title guaranteed to be present?
  const groupedItems = groupBy(items, "cover.title");

  return (
    <Block>
      {Object.entries(groupedItems).map(([coverTitle, items]) => (
        <Block key={coverTitle}>
          <HeadingSmall>{coverTitle}</HeadingSmall>
          <UL>
            {items.map((item, index) => (
              <LI
                key={`${index}_${item.key}`}
                artwork={artwork}
                marginBottom="scale500"
                marginRight="scale600"
              >
                <ParagraphMedium margin={0}>{item.text}</ParagraphMedium>
                {item.description && (
                  <UL>
                    <LI>
                      <ParagraphXSmall margin={0} color="mono700">
                        {item.description}
                      </ParagraphXSmall>
                    </LI>
                  </UL>
                )}
              </LI>
            ))}
          </UL>
        </Block>
      ))}
    </Block>
  );
};

export { CoverLimitationsList, CoverLimitationsGroupedList };
